import { commonEnums, Utils } from '@codametrix/ui-common';
import { CmAlertDialog, Form } from '@codametrix/ui-components';
import React from 'react';
import './styles/index.scss';
export type CaseCancellationProps = Accelerate.BenchApplicationState & {
  onCaseCancelDismiss: (
    ev: React.MouseEvent | React.FormEvent | CustomEvent
  ) => void;
  onCaseCancel: (submission: AmplifyAPI.Submission) => void;
};

type InvoiceEditorState = {};

const formDef = {
  buttons: [
    {
      className: 'add-button',
      buttonType: 'submit',
      buttonText: 'Proceed'
    },
    {
      buttonText: 'dismiss',
      buttonType: 'link',
      action: 'cancel',
      link: '/go/elsewhere'
    }
  ]
};

class CaseCancellation extends React.Component<
  CaseCancellationProps,
  InvoiceEditorState
> {
  private cancelButtonRef = React.createRef<HTMLButtonElement>();

  constructor(props: CaseCancellationProps) {
    super(props);
    this.handleCancelDismiss = this.handleCancelDismiss.bind(this);
    this.handleCaseCancel = this.handleCaseCancel.bind(this);
  }

  handleCancelDismiss(event?: React.MouseEvent | React.FormEvent | CustomEvent) {
    event?.preventDefault();
    this.props.onCaseCancelDismiss(event);
  }

  handleCaseCancel(event: React.MouseEvent | React.FormEvent | CustomEvent) {
    event.preventDefault();
    const cursorAPIPayload = {
      operation: commonEnums.CursorOperation.NEXT,
      cursorAPIContext: this.props.cursorAPIContext,
      hasAmplifyCaseRunV2Access: Utils.doesPathEndWithV2()
    };
    this.props.onCaseCancel({
      processInstance: this.props.processInstance,
      uiMode: this.props.UIMode,
      cursorAPIPayload
    });
  }

  render() {
    const { displayCancellation } = this.props;

    if (!displayCancellation)
      return <span className="case-cancellation-empty"></span>;

    return (
      <div className="case-cancellation-form">
        <CmAlertDialog
          isOpen={true}
          onClose={this.handleCancelDismiss}
          title="Void this case?"
          leastDestructiveRef={this.cancelButtonRef}
          footer={
            <>
              <button
                ref={this.cancelButtonRef}
                type="button"
                onClick={this.handleCancelDismiss}
                className="chakra-secondary-button cancel-link qa-cancel-link">
                No, Cancel
              </button>
              <button
                type="button"
                onClick={this.handleCaseCancel}
                className="chakra-primary-button qa-rounded-button">
                Yes, Void
              </button>
            </>
          }>
          <div className="cols">
            <div className="cmx-col-12">
              <p className="void-subtitle">
                Voided cases are not submitted for reimbursement, and will no
                longer be editable.
              </p>
            </div>
          </div>
        </CmAlertDialog>
      </div>
    );
  }
}

export { CaseCancellation };
